import type { FinancialAccount } from "@porchpass/ui";
import type { DomainAssetType } from "@porchpass/api-client";
import type { FinancialAccountFormData } from "src/types/financial-accounts";
import { fieldErrorsAfterSubmitRecord } from "src/forms/fieldErrorsAfterSubmit";

const UI_TO_DLA_FIELD: Partial<
  Record<keyof FinancialAccount, keyof FinancialAccountFormData>
> = {
  accountType: "account_type",
  institutionName: "institution_name",
  balance: "balance_amount",
};

export function toUiFinancialAccount(
  dto: FinancialAccountFormData,
): FinancialAccount {
  return {
    id: dto.id,
    accountType: (dto.account_type ?? "") as DomainAssetType,
    institutionName: dto.institution_name ?? "",
    balance:
      dto.balance_amount != null && dto.balance_amount !== ""
        ? Number(dto.balance_amount)
        : undefined,
  };
}

export function fromUiFinancialAccountPatch(
  patch: Partial<FinancialAccount>,
): Partial<FinancialAccountFormData> {
  const mapped: Partial<FinancialAccountFormData> = {};

  for (const [uiKey, value] of Object.entries(patch)) {
    const dlaKey = UI_TO_DLA_FIELD[uiKey as keyof FinancialAccount];
    if (!dlaKey || value === undefined) continue;

    if (uiKey === "balance") {
      mapped.balance_amount = String(value);
    } else if (dlaKey === "account_type") {
      mapped.account_type = value as FinancialAccountFormData["account_type"];
    } else if (dlaKey === "institution_name") {
      mapped.institution_name = value as string;
    }
  }

  return mapped;
}

export function financialAccountErrorsAfterSubmit<
  T extends {
    account_type?: { message?: string };
    institution_name?: { message?: string };
    balance_amount?: { message?: string };
  },
>(formErrors: T, hasAttemptedFormSubmission: boolean): Record<string, string> {
  return fieldErrorsAfterSubmitRecord(
    {
      accountType: formErrors.account_type?.message,
      institutionName: formErrors.institution_name?.message,
      balance: formErrors.balance_amount?.message,
    },
    hasAttemptedFormSubmission,
  );
}
